import axios from 'axios';
import { getApiBase } from './config/env';

const api = axios.create();

// baseURL dynamique
api.interceptors.request.use((config) => {
  const base = getApiBase();
  if (base) {
    config.baseURL = base;
  }
  return config;
});

// Rate-limiting queue — backend allows 20 req / 10 s
// 2 000 ms minimum between any two requests → max 5 req / 10 s per client
let lastRequestTime = 0;
const MIN_GAP_MS = process.env.NODE_ENV === 'production' ? 2000 : 0;

api.interceptors.request.use(async (config) => {
  const now = Date.now();
  const elapsed = now - lastRequestTime;
  if (elapsed < MIN_GAP_MS) {
    await new Promise(resolve => setTimeout(resolve, MIN_GAP_MS - elapsed));
  }
  lastRequestTime = Date.now();
  return config;
});

// Injecte le token JWT dans chaque requete
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Redirige vers /login sur 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
